import React from 'react';
import styles from './index.module.scss';
import { BaseInfoProps } from '../..';
import { formatThousandUnit } from '@/utils/utils';

export interface CostBannerProps {
  baseInfo?: BaseInfoProps;
}

const CostBanner = ({ baseInfo }: CostBannerProps) => {
  return (
    <div className={styles.cardWrapper}>
      <div className={styles.left}>
        <div className={styles.unit}>总用能成本（元）</div>
        <div className={styles.specific}>
          <div className={styles.num}>{formatThousandUnit(baseInfo?.totalCost)}</div>
          {/* <div className={styles.val}>
            <span>环比</span>
            <span className={styles[baseInfo?.sign!]}>
              {baseInfo?.sign === SignType.PLUS ? '+' : ''}
              {baseInfo?.cycleRatio ?? '--'}%
            </span>
          </div> */}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.peakVal}>
          <div className={styles.valLine}>
            <div>最大用能成本（元）</div>
            <div></div>
            <div>{formatThousandUnit(baseInfo?.maxDetail?.value)}</div>
            <div>{baseInfo?.maxDetail?.time ?? '--'}</div>
          </div>
          <div className={styles.valLine}>
            <div>最小用能成本（元）</div>
            <div></div>
            <div>{formatThousandUnit(baseInfo?.minDetail?.value)}</div>
            <div>{baseInfo?.minDetail?.time ?? '--'}</div>
          </div>
        </div>
        <div className={styles.menuVal}>
          <div>用能成本均值（元）</div>
          <div>{formatThousandUnit(baseInfo?.avgCost)}</div>
        </div>
      </div>
    </div>
  );
};

export default CostBanner;
